/* 
 * DialogPlayerTimerMediator.js
 * 
 * @author Olivier van der Pool for Ranj
 */

import NGTDialogPlayerEvent from "../NGTDialogPlayerEvent";

export default class DialogPlayerTimerMediator {
    constructor(target, dispatcher) {
        this._skin = target;
        this._dispatcher = dispatcher;
    }

    initialize() {
        this._skin.visible = false; //stay invisible until the fist time tick occured
        this._timeValue = 0; //the timer time value in milliseconds

        this._addEventListeners();
    }

    destroy() {
        this._removeEventListeners();
    }

    _addEventListeners() {
        this._handleTimeTickFunction = this._handleTimeTick.bind(this);
        this._handleTimeOutFunction = this._handleTimeOut.bind(this);
        this._dispatcher.addEventListener(NGTDialogPlayerEvent.DIALOG_TIMER, this._handleTimeTickFunction);
        this._dispatcher.addEventListener(NGTDialogPlayerEvent.DIALOG_TIME_OUT, this._handleTimeOutFunction);
    }

    _removeEventListeners() {
        this._dispatcher.removeEventListener(NGTDialogPlayerEvent.DIALOG_TIMER, this._handleTimeTickFunction);
        this._dispatcher.removeEventListener(NGTDialogPlayerEvent.DIALOG_TIME_OUT, this._handleTimeOutFunction);
        this._handleTimeTickFunction = null;
        this._handleTimeOutFunction = null;
    }

    _handleTimeTick({ params }) {
        if (!this._skin.visible) this._skin.visible = true;

        this._timeValue = params.data;
        this._updateTime();
    }

    _handleTimeOut(event) {
        // do nothing!
    }

    _updateTime() {
        let s = this._timeValue;
        if (s < 0) s = 0;

        const ms = s % 1000;
        s = (s - ms) / 1000;
        const secs = s % 60;
        s = (s - secs) / 60;
        const mins = s % 60;

        const secsUnits = secs % 10;
        const secsTens = (secs - secsUnits) / 10;

        const minsUnits = mins % 10;
        const minsTens = (mins - minsUnits) / 10;

        this._skin.minutesDoubleTimerTextField.text = minsTens;
        this._skin.minutesSingleTimerTextField.text = minsUnits;
        this._skin.secondsDoubleTimerTextField.text = secsTens;
        this._skin.secondsSingleTimerTextField.text = secsUnits;

        //this._skin.timeField.text = minsTens + minsUnits + ':' + secsTens + secsUnits;
    }
}
